import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient, {publicAxiosClient} from '../AxiosClient'
export const bigcommerceGetURL = createAsyncThunk(
  'bigcommerce/getURL',
  async function (payload:any, toolkit) {
    // console.log(payload)
    return await AxiosClient('GET', '/bigcommerce-oauth-callback'+payload.parm, [], toolkit, [])
  }
)